import { renderImageHalftone } from '../core/image-halftone/build-config';
import type { PatternState, Render2DContext, RenderFn } from '../types';

export const renderHalftone: RenderFn = (
  ctx: Render2DContext,
  width: number,
  height: number,
  state: PatternState,
) => {
  renderImageHalftone(ctx, width, height, state);
};
